import componentMockController from './componentMock.controller';

export default {
    template: require('./componentMock.html'),
    controller: componentMockController
};
